import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { UploadReqWorkFlowStepWarningModalComponent } from './upload-req-work-flow-step-warning-modal.component';

@NgModule({
  declarations: [UploadReqWorkFlowStepWarningModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot()
  ],
  exports: [UploadReqWorkFlowStepWarningModalComponent],
  entryComponents: [UploadReqWorkFlowStepWarningModalComponent]
})
export class UploadReqWorkFlowStepWarningModalModule { }
